module.exports = __webpack_public_path__ + "static/img/p2.e625b02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/a-view-outside/p2.png
// module id = lKtq
// module chunks = 0